import { redirect } from "./domUtils";

import {
  APP_DEFAULT_ADMIN_HOME_ROUTE,
  APP_DEFAULT_CLIENT_HOME_ROUTE,
} from "../config/appConfig";

/**
 * @description Revisa el estado del usuario a travez de las props para redirigir a la pagina configurada
 * @param props { auth }
 */
export const checkUserLoggedIn = (props) => {
  // @ts-ignore
  if (props?.auth?.isLoggedIn === true) {
    // @ts-ignore
    if (
      props?.auth?.user?.dashboard === true ||
      props?.auth?.user?.admin === true
    ) {
      redirect(APP_DEFAULT_ADMIN_HOME_ROUTE);
    } else {
      redirect(APP_DEFAULT_CLIENT_HOME_ROUTE);
    }
  }
};
